import React, { useEffect, useRef, useState } from "react";
import { checkout, config, orderbook } from "@imtbl/sdk";
import { passportInstance } from "../context/PassportService";
import GreenIsotype from "../assets/img/GreenIsotype.png";

import styled from "styled-components";
import MarketPlaceItemCard from "../components/Marketplace/MarketPlaceItemCard";
import FilterOption from "../components/Marketplace/FilterOption";
import FilterSection from "../components/Marketplace/FilterSection";
import { getData } from "../api/ApiRequest";
import { fetchMarketPlaceItems } from "../context/QorbiService";
import GradientButton from "../components/GradientButton";
import FilterIcon from "../assets/svg/FilterIcon";
import MobileMarketFilter from "../components/Modals/MobileMarketFilter";

const baseConfig = new config.ImmutableConfiguration({
  environment: config.Environment.SANDBOX,
});

const StyledMarketPlace = styled.div`
  width: 100vw;
  margin: 65px 0px 0px 0px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  font-family: "exo", sans-serif !important;

  html {
    overflow: scroll;
    font-family: "exo", sans-serif !important;
  }

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }

  .content-section-container {
    height: 100%;
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    flex: 2;
  }

  #market-title-description {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    margin: 35px 25px 35px 25px;
  }

  #market-title {
    font-size: 34px;
    font-weight: 700;
    line-height: 40px;
    color: #ffffff;
    margin: 0px;
  }

  #market-description {
    font-size: 20px;
    font-weight: 300;
    line-height: 44px;
    color: #a6a6a6;
    margin: 0px;
  }

  #assets-store-container {
    width: 100%;
    flex: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
    flex-wrap: wrap;
    overflow-y: scroll;
    padding-bottom: 25px;
  }

  .empty-items-container {
    height: 50vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
      margin: 0px;
      font-size: 22px;
      color: #ffffff;
      font-weight: 700;
      line-height: 19px;
      font-family: "exo", sans-serif !important;
    }
  }

  #reload-items-button {
    width: 246px;
    height: 47px;
    margin-top: 30px;
    border-radius: 14px;
    background: linear-gradient(#38ef7d, #11998e);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
    color: #ffffff;
    font-weight: 500;
    line-height: 19px;
  }

  #loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vh;
    width: 100%;

    img {
      height: 120px;
      width: 120px;
      margin-bottom: 25px;
    }

    p {
      color: #ffffff;
      font-size: 22px;
      font-weight: 600;
      line-height: 20px;
      margin: 0px;
      font-family: "exo", sans-serif !important;
    }
  }

  #mobile-filter-button {
    height: 54px;
    width: 54px;
    border-radius: 100px;
    background: #1c1c1c;
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 90px;
    right: 20px;
  }

  @media (width <= 700px) {
    #mobile-filter-button {
      display: flex;
    }

    #desktop-filter-section {
      display: none;
    }
  }
`;

const orderbookClient = new orderbook.Orderbook({
  baseConfig: {
    environment: config.Environment.PRODUCTION,
    publishableKey: "pk_imapik-_PHi3-wNvsLJhnzG4DEj",
  },
});

const checkoutSDK = new checkout.Checkout({ baseConfig });

const ZkMarketplace = () => {
  // Constants
  const contractAddress = useRef("0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd"); //Skins by default

  // States
  const [widget, setWidget] = useState(undefined);
  const [provider, setProvider] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [listings, setListings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  const [filteredListing, setFilteredListing] = useState([]);
  const mobileFilterModalRef = useRef();

  // Get Listings
  const listListings = async (contractAddress) => {
    const { result } = await orderbookClient.listListings({
      sellItemContractAddress: contractAddress,
      status: orderbook.OrderStatusName.ACTIVE,
      pageSize: 50,
    });
    return result;
  };

  const handleListListings = async () => {
    setIsLoading(true);
    try {
      //Get all kind of assets
      let skins = await listListings(
        "0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd"
      );
      let badges = await listListings(
        "0x2e1dac6efc5fa1a145112a918f422aa2acea6871"
      );
      let qorbs = await listListings(
        "0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d"
      );
      let qorxpasses = await listListings(
        "0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757"
      );
      let pets = await listListings(
        "0x7a6d3FB14A2eEFD8173584a96ABD2fAFA08e396a"
      );
      setListings([
        ...listings,
        ...skins,
        ...badges,
        ...qorbs,
        ...qorxpasses,
        ...pets,
      ]);
    } catch (error) {
      console.error("Error listing assets:", error);
    } finally {
      setIsLoading(false);
    }
  };

  async function fetchItems() {
    var response = fetchMarketPlaceItems();
    var data = await response;
    setListings(data);
    setFilteredListing(data);
  }

  // Create Listing
  const prepareERC1155Listing = async () => {
    // build the sell item
    const sell = {
      contractAddress,
      tokenId: "699",
      amount: "1",
      type: "ERC1155",
    };
    // build the buy item
    const buy = {
      amount: "1000000000000000000",
      type: "NATIVE",
    };

    // build the prepare listing parameters
    const prepareListingParams = {
      makerAddress: walletAddress,
      buy,
      sell,
    };
    // invoke the orderbook SDK to prepare the listing
    return await orderbookClient.prepareListing(prepareListingParams);
  };

  const signAndSubmitApproval = async (provider, listing) => {
    // get your user's Web3 wallet, e.g. MetaMask, Passport, etc
    const signer = provider.getSigner();

    // If the user hasn't yet approved the Immutable Seaport contract to transfer assets from this
    // collection on their behalf they'll need to do so before they create an order
    const approvalActions = listing.actions.filter(
      (action) => action.type === orderbook.ActionType.TRANSACTION
    );

    for (const approvalAction of approvalActions) {
      const unsignedTx = await approvalAction.buildTransaction();
      const receipt = await signer.sendTransaction(unsignedTx);
      await receipt.wait();
    }

    return;
  };

  const signListing = async (provider, listing) => {
    const signer = provider.getSigner();
    console.log(1.1);
    const signableAction = listing.actions.find(
      (action) => action.type === orderbook.ActionType.SIGNABLE
    );
    console.log(1.2);
    console.log(signableAction);
    const signature = await signer._signTypedData(
      signableAction.message.domain,
      signableAction.message.types,
      signableAction.message.value
    );
    console.log(1.3);
    return signature;
  };

  const createListing = async (
    client,
    preparedListing,
    orderSignature,
    makerEcosystemFee
  ) => {
    const order = await client.createListing({
      orderComponents: preparedListing.orderComponents,
      orderHash: preparedListing.orderHash,
      orderSignature,
      // Optional maker marketplace fee
      makerFees: makerEcosystemFee
        ? [
            {
              recipientAddress: makerEcosystemFee.recipientAddress, // Replace address with marketplace address 0xF3F1e9D508D4a8f3620050E51aae8597b9dcaf48
              amount: makerEcosystemFee.amount,
            },
          ]
        : [],
    });
    console.log(order);
    return order.result.id;
  };

  const handleCreateListing = async () => {
    try {
      console.log(1);
      const preparedListing = await prepareERC1155Listing();
      console.log(2);
      await signAndSubmitApproval(provider, preparedListing);
      console.log(3);
      const signature = await signListing(provider, preparedListing);
      console.log(4);
      const orderId = await createListing(
        orderbookClient,
        preparedListing,
        signature
      );
      console.log(5);
      console.log("Order created with ID:", orderId);
    } catch (error) {
      console.error("Error creating listing:", error);
    }
  };

  async function loadAllAssets() {
    setIsLoading(true);
    await fetchItems();
    // await handleListListings();
    setIsLoading(false);
  }

  // Use Effects
  useEffect(() => {
    loadAllAssets();
    if (passportInstance) {
      passportInstance.connectEvm();
    }
  }, []);

  useEffect(() => {
    if (!widget) return;

    widget.mount("mount-point", {
      flow: checkout.CommerceFlowType.CONNECT,
    });

    widget.addListener(checkout.CommerceEventType.SUCCESS, async (payload) => {
      const { type, data } = payload;

      if (type === checkout.CommerceSuccessEventType.CONNECT_SUCCESS) {
        setProvider(data.provider);
        // const accounts = await passportInstance.connectEvm().request({ method: 'eth_accounts' });
        const accounts = await data.provider.provider.request({
          method: "eth_accounts",
        });
        if (accounts && accounts.length > 0) {
          setWalletAddress(accounts[0]);
        }

        widget.unmount();
      }
    });

    widget.addListener(checkout.CommerceEventType.FAILURE, (payload) => {
      console.log("Failed to connect", payload.data.reason);
    });

    widget.addListener(checkout.CommerceEventType.CLOSE, () => {
      widget.unmount();
    });

    return () => {
      widget.removeListener(checkout.CommerceEventType.SUCCESS);
      widget.removeListener(checkout.CommerceEventType.FAILURE);
      widget.removeListener(checkout.CommerceEventType.CLOSE);
    };
  }, [widget]);

  function deepCopyWithFilter(array, predicate) {
    return array
      .filter(predicate)
      .map((item) =>
        typeof item === "object" && item !== null ? structuredClone(item) : item
      );
  }

  function onFilterChanged(categories) {
    var filteredList = deepCopyWithFilter(listings, (element) => {
      return categories.includes(element.contract_address);
    });
    setFilteredListing(filteredList);
    if (categories.length == 0) {
      setIsFiltering(false);
    } else {
      setIsFiltering(true);
    }
  }

  return (
    <StyledMarketPlace>
      <MobileMarketFilter
        ref={mobileFilterModalRef}
        onFilterChanged={onFilterChanged}
      ></MobileMarketFilter>
      <div id="desktop-filter-section">
        <FilterSection onFilterChanged={onFilterChanged}></FilterSection>
      </div>
      <div
        id="mobile-filter-button"
        onClick={() => mobileFilterModalRef.current.open()}
      >
        <FilterIcon></FilterIcon>
      </div>
      <div className="content-section-container">
        <div id="assets-store-container">
          <div id="market-title-description">
            <p id="market-title">My Collection</p>
            <p id="market-description">
              Explore unique pets, stunning skins, badges, collectible Qorbs,
              and exclusive Qorx passes. Elevate your gameplay and stand out
              today!
            </p>
          </div>
          {isLoading && (
            <div id="loading-container">
              <img src={GreenIsotype} />
              <p>Loading Items...</p>
            </div>
          )}
          {!isLoading && listings.length == 0 && (
            <div className="empty-items-container">
              <p>No Items Found</p>
              <GradientButton
                onTap={loadAllAssets}
                text={"Reload"}
              ></GradientButton>
            </div>
          )}
          {!isLoading && isFiltering
            ? filteredListing.length > 0 &&
              filteredListing.map((item, index) => (
                <MarketPlaceItemCard
                  key={`market_place_card${index}`}
                  item={item}
                ></MarketPlaceItemCard>
              ))
            : listings.length > 0 &&
              listings.map((item, index) => (
                <MarketPlaceItemCard
                  key={`market_place_card${index}`}
                  item={item}
                ></MarketPlaceItemCard>
              ))}
        </div>
      </div>
    </StyledMarketPlace>
  );
};

export default ZkMarketplace;
